import { Controller } from "@hotwired/stimulus"

// 숫자 카운트업 애니메이션 컨트롤러
export default class extends Controller {
  static values = {
    target: Number,    // 목표 숫자
    duration: { type: Number, default: 1500 },  // 애니메이션 지속 시간 (ms)
    prefix: { type: String, default: "" },
    suffix: { type: String, default: "" }
  }

  connect() {
    this.startValue = 0
    this.currentValue = 0
    this.startTime = null

    // Intersection Observer로 화면에 보일 때만 애니메이션 시작
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          this.animate()
          observer.unobserve(this.element)
        }
      })
    }, { threshold: 0.1 })

    observer.observe(this.element)
  }

  animate() {
    this.startTime = performance.now()
    requestAnimationFrame(this.step.bind(this))
  }

  step(currentTime) {
    if (!this.startTime) this.startTime = currentTime

    const progress = Math.min((currentTime - this.startTime) / this.durationValue, 1)

    // easeOutExpo 이징 함수
    const easeOutExpo = progress === 1 ? 1 : 1 - Math.pow(2, -10 * progress)

    this.currentValue = Math.floor(easeOutExpo * this.targetValue)

    this.element.textContent = this.formatNumber(this.currentValue)

    if (progress < 1) {
      requestAnimationFrame(this.step.bind(this))
    } else {
      // 최종값 표시 (정확한 값)
      this.element.textContent = this.formatNumber(this.targetValue)
    }
  }

  formatNumber(num) {
    const formatted = new Intl.NumberFormat("ko-KR").format(num)
    return `${this.prefixValue}${formatted}${this.suffixValue}`
  }
}
